// src/components/WaveText.js
import React from 'react';
import { motion } from 'framer-motion';
import './WaveText.css';

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.05,
      repeat: Infinity,
      repeatDelay: 30,
    },
  },
};

const childVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: "spring",
      stiffness: 100,
    },
  },
};

const WaveText = ({ text }) => {
  return (
    <motion.div
      className="wave-text"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      aria-label={text} // Accessibilité
    >
      {text.split("").map((char, index) => (
        <motion.span
          key={index}
          variants={childVariants}
          className={char === ' ' ? 'space' : ''} // Gestion des espaces
        >
          {char}
        </motion.span>
      ))}
    </motion.div>
  );
};

export default WaveText;